var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2259 20.1669C9.98382 20.1669 8.77291 20.1531 7.57482 20.1284C6.04216 20.0981 4.98157 19.1045 4.80832 17.5351C4.51957 14.9318 4.02549 8.79564 4.02091 8.73422C3.98974 8.35564 4.27207 8.0238 4.65066 7.99355C5.02374 7.98347 5.36107 8.24564 5.39132 8.6233C5.39591 8.68564 5.88907 14.8007 6.17507 17.3839C6.27316 18.2758 6.75441 18.736 7.60324 18.7534C9.89491 18.802 12.2333 18.8047 14.7542 18.7589C15.6562 18.7415 16.1438 18.2905 16.2447 17.3775C16.5288 14.8163 17.0238 8.68564 17.0293 8.6233C17.0596 8.24564 17.3942 7.98164 17.7691 7.99355C18.1477 8.02472 18.43 8.35564 18.3997 8.73422C18.3942 8.79655 17.8974 14.9483 17.6114 17.5287C17.4336 19.1301 16.3757 20.1046 14.7789 20.1339C13.557 20.155 12.3782 20.1669 11.2259 20.1669Z",
    fill: "#CD8F6C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9823 6.40723H3.4375C3.058 6.40723 2.75 6.09923 2.75 5.71973C2.75 5.34023 3.058 5.03223 3.4375 5.03223H18.9823C19.3618 5.03223 19.6698 5.34023 19.6698 5.71973C19.6698 6.09923 19.3618 6.40723 18.9823 6.40723Z",
    fill: "#CD8F6C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.987 6.40723C14.9439 6.40723 14.0382 5.66382 13.8329 4.64082L13.6101 3.52615C13.5634 3.35657 13.37 3.20898 13.15 3.20898H9.2697C9.0497 3.20898 8.85628 3.35657 8.80037 3.56832L8.58678 4.64082C8.38237 5.66382 7.47578 6.40723 6.43262 6.40723C6.05312 6.40723 5.74512 6.09923 5.74512 5.71973C5.74512 5.34023 6.05312 5.03223 6.43262 5.03223C6.82312 5.03223 7.16228 4.75357 7.23928 4.3704L7.46203 3.25573C7.68845 2.4014 8.4282 1.83398 9.2697 1.83398H13.15C13.9915 1.83398 14.7312 2.4014 14.9485 3.21448L15.1813 4.3704C15.2574 4.75357 15.5965 5.03223 15.987 5.03223C16.3665 5.03223 16.6745 5.34023 16.6745 5.71973C16.6745 6.09923 16.3665 6.40723 15.987 6.40723Z",
    fill: "#CD8F6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.570b002bcc81124fce4ebe55cd4a8f09.svg";
export { ForwardRef as ReactComponent };